export default __webpack_public_path__ + "static/media/046-micronesia.c007f0bb.svg";